import type * as Sentry from '@sentry/browser'
import type { Location } from '~/core/router'

import { Logger } from '~/shared/logger'
import { UNKNOWN_PREVIOUS_LOCATION } from './index.h'

export const logger = new Logger('tria/sentry')

/**
 * Composes href from location
 */
const href = (location?: Location | null): string =>
  location
    ? `${location.pathname}${location.search}${location.hash}`
    : UNKNOWN_PREVIOUS_LOCATION

/**
 * Composes breadcrumbs from previous locations
 */
export const toBreadcrumbs = (locations: (Location | null)[] | null) =>
  locations ? locations.map(href).reverse() : []

/**
 * Checks if the error should be ignored
 */
export function isIgnoredError(event: Sentry.Event): boolean {
  if (!Array.isArray(event?.extra?.arguments)) {
    return false
  }

  for (const arg of event.extra.arguments) {
    if (arg == null) continue

    if (typeof arg === 'object' && typeof arg.name === 'string') {
      // ignore errors related to QuotaExceededError
      if (arg.name.includes('QuotaExceededError')) {
        return true
      }
    }

    if (typeof arg === 'string') {
      // ignore errors related to Firebase Analytics
      if (arg.includes('@firebase/analytics')) {
        return true
      }

      // ignore errors related to Setplex Analytix
      if (arg.includes('[STPNORAAnalytix]')) {
        return true
      }

      // ignore errors related to videojs
      if (arg.includes('VIDEOJS')) {
        return true
      }
    }
  }

  return false
}
